var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"copyright"},[_vm._v("Copyright 2023 Moritz Siefke")])])
}]

export { render, staticRenderFns }